import {
  computed, observable, makeObservable,
  makeAutoObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { navigate } from 'gatsby';
import { AttachmentType, PAGE_SIZE,  PlatformType, VmList } from '../constants/options';
import { SetLocalStorage } from '../utilities/cryptography';
import { USER_INFO } from '../constants/storage-keys';
import { FAxios } from '../utilities/file-network';

export default class NewsStore {

  loading: boolean = false;

  loadingInfo: boolean = false;

  loadingCategories: boolean = false;

  uploading: boolean = false;
  deletingFile: boolean = false;
  downloading: boolean = false;
  updatingDocumentName: boolean = false;

  uploadedNewsImgHashCache = new Map<string, string>();

  news: VmList = { totalCount: 0, items: [] };
  newsInfo: any = null;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {});
    this.rootStore = rootStore;
  }

  getNewsCategories = async () => {
    this.loadingCategories = true;
    try {
      const res = await Axios.post(`/api/News/Category/Search/0/0`, {});
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingCategories = false;
    }
  };

  searchNewsList = async (skip: number, take: number, reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/News/Search/${skip}/${take}`, reqModel);
      // const res = await Axios.post(`/api/News/Search?skip=${skip}&take=${take}`, reqModel);
      this.news = res.data;
      // console.log("maintenance", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createNews = async (reqModel: any) => {
    this.loadingInfo = true;
    try {
      const res = await Axios.post(`/api/News`, reqModel);
      this.newsInfo = res.data;
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingInfo = false;
    }
  };

  getNews = async (id: number) => {
    this.loadingInfo = true;
    try {
      const res = await Axios.get(`/api/News/${id}`);
      this.newsInfo = res.data;
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingInfo = false;
    }
  };

  updateNews = async (reqModel: any) => {
    this.loadingInfo = true;
    try {
      const res = await Axios.put(`/api/News`, reqModel);
      this.newsInfo = res.data;
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingInfo = false;
    }
  };

  deleteNews = async (id: number) => {
    this.loadingInfo = true;
    try {
      const res = await Axios.delete(`/api/News/${id}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingInfo = false;
    }
  };

  getNewsAttachment = async (id: any) => {
    this.downloading = true;
    try {
      const res = await FAxios.get(`/api/News/Attachment/${id}?platformId=${PlatformType.ADMIN_WEB}`, { responseType: 'blob' });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.downloading = false;
    }
  };

  uploadNewsAttachment = async ( file: any) => {
    this.uploading = true;
    try {
      const res = await Axios.post(`/api/News/Attachment?platformId=${PlatformType.ADMIN_WEB}`, file);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.uploading = false;
    }
  };


  renameNewsAttachment = async (reqModel: {
    newsId: number,
    attachmentCategoryId: number,
    originalName: string,
    id: number,
  }) => {
    this.updatingDocumentName = true;
    try {
      const res = await Axios.put(`/api/News/Attachment?platformId=${PlatformType.ADMIN_WEB}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.updatingDocumentName = false;
    }
  };

  deleteNewsAttachment = async (name: string) => {
    this.deletingFile = true;
    try {
      const res = await Axios.delete(`/api/News/Attachment/${name}?platformId=${PlatformType.ADMIN_WEB}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.deletingFile = false;
    }
  };
}
